<template>
    <div class="western">
        <div class="western__headers row">
            <div class="col-6 col-md-8">
                Western Optional Fees
                <div v-if="!admin" class="fee__info mb-1">
                    As an affiliate of Western, King’s students are charged for services/programs offered by Western.
                    All funds are transferred to Western for these services. For more information about these fees,
                    please contact Western at <a href="mailto:reg-fees@uwo.ca">reg-fees@uwo.ca</a>.
                </div>
            </div>
            <div class="col-3 col-md-2">
                Value
            </div>
            <div class="col-3 col-md-2">
                Opt-Out
            </div>
        </div>
        <div class="western__fees">
            <div class="row mb-2" :class="[{ 'opt__out' : internationalStudentServices.optOut }]">
                <div class="col-6 col-md-8">
                    <div class="form__fee-title">
                        <div class="fee__header">
                            International Student Services
                        </div>
                        <div v-if="!admin" class="fee__info">
                            This fee supports international learning and programs in support of international students.
                            This fee supports graduate and undergraduate students throughout their university careers by
                            providing opportunities to gain intercultural skills and experiences and by creating a
                            diverse and welcoming community at Western. Services support intercultural learning,
                            volunteer opportunities for more than 400 students per year, international student
                            orientation, advising, events and activities, English conversation program, intercultural
                            learning, peer guide program, immigration assistance and more.
                        </div>
                    </div>
                </div>
                <div class="col-3 col-md-2">
                    <div class="form__fee-value">
                        $ {{ internationalStudentServices.amount }}
                    </div>
                </div>
                <div class="col-3 col-md-2">
                    <div class="form-check form__fee-check">
                        <input type="checkbox" id="western-international-student-services"
                            name="western-international-student-services" value="opt-out"
                            aria-label="international student services" v-model="internationalStudentServices.optOut"
                            @change="optOut(internationalStudentServices)" :disabled="submitted">
                    </div>
                </div>
            </div>
            <div class="row mb-2" :class="[{ 'opt__out' : offCampusHousingServices.optOut }]">
                <div class="col-6 col-md-8">
                    <div class="form__fee-title-even">
                        <div class="fee__header">
                            Off-Campus Housing & Housing Mediation Services
                        </div>
                        <div v-if="!admin" class="fee__info">
                            This fee provides: 1) mediation services to resolve landlord, tenant and roommate conflicts;
                            2) access to hundreds of rental listings; 3) a lease review service; and 4) personal
                            advising from Western staff members to assist with your search for housing. Opting out of
                            this fee means: 1) you will not have support to ensure the terms of your lease adhere to the
                            Ontario rental law; 2) you will not have mediation services available to assist with
                            resolving conflicts with your landlord and/or roommate; and 3) you will not be able to
                            advertise subletting or sharing your unit via our online listing service.
                        </div>
                    </div>
                </div>
                <div class="col-3 col-md-2">
                    <div class="form__fee-value-even">
                        $ {{ offCampusHousingServices.amount }}
                    </div>
                </div>
                <div class="col-3 col-md-2">
                    <div class="form-check form__fee-check-even">
                        <input type="checkbox" id="western-offcampus-mediation-housing-services"
                            name="western-offcampus-mediation-housing-services" value="opt-out"
                            aria-label="off-campus housing and housing mediation services"
                            v-model="offCampusHousingServices.optOut" @change="optOut(offCampusHousingServices)"
                            :disabled="submitted">
                    </div>
                </div>
            </div>
            <div class="row" :class="[{ 'opt__out' : disabilitiesServices.optOut }]">
                <div class="col-6 col-md-8">
                    <div class="fee__header">
                        Services for Students with Disabilities
                    </div>
                    <div v-if="!admin" class="fee__info">
                        This fee supports the programs, resources and supports that enhance support for students with
                        disabilities.
                    </div>
                </div>
                <div class="col-3 col-md-2">
                    $ {{ disabilitiesServices.amount }}
                </div>
                <div class="col-3 col-md-2">
                    <div class="form-check">
                        <input type="checkbox" id="western-disabilities-services" name="western-disabilities-services"
                            aria-label="services for students with disabilities" value="opt-out"
                            v-model="disabilitiesServices.optOut" @change="optOut(disabilitiesServices)"
                            :disabled="submitted">
                    </div>
                </div>
            </div>
        </div>
        <div :class="[total > 0 ? 'western__fee' : 'western__nofee', 'western__total']">
            <div class="row">
                <div class="col-6 col-md-8">
                    Total Western Optional Fees
                </div>
                <div class="col-6 col-md-4">
                    $ {{ total }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'form-western',
    props: {
        admin: {
            type: Boolean
        },
        userData: {
            type: Object
        },
        submitted: {
            type: Boolean
        }
    },
    data() {
        return {
            internationalStudentServices: {
                amount: "8.84",
                optOut: false
            },
            offCampusHousingServices: {
                amount: "9.36",
                optOut: false
            },
            disabilitiesServices: {
                amount: "17.00",
                optOut: false
            },
            total: "0.00"
        }
    },
    methods: {
        optOut(fee) {
            // Opt-out calcuation
            if (!fee.optOut) {
                this.total = Number.parseFloat(this.total) + Number.parseFloat(fee.amount);
            } else {
                this.total = Number.parseFloat(this.total) - Number.parseFloat(fee.amount);
            }

            // Currency parse and format
            this.total = Number.parseFloat(this.total).toFixed(2);

            // Update sci total fees
            this.$emit('getWesternTotal', this.total);
        },
        getFee(fee) {
            if (fee.match(/international/i)) {
                return this.internationalStudentServices;
            } else if (fee.match(/housing/i)) {
                return this.offCampusHousingServices;
            } else if (fee.match(/disabilities/i)) {
                return this.disabilitiesServices;
            } else {
                return false;
            }
        },
        getTotalFees() {
            // Total float calcuation
            this.total =
                Number.parseFloat(this.internationalStudentServices.amount) +
                Number.parseFloat(this.offCampusHousingServices.amount) +
                Number.parseFloat(this.disabilitiesServices.amount);

            // Currency parse and format
            this.total = Number.parseFloat(this.total).toFixed(2);
        }
    },
    created() {
        // Total King's Student Optional Fees
        this.getTotalFees();

        // Update sci total fees
        this.$emit('getWesternTotal', this.total);

        // Formdata handler
        if (this.userData.result && this.userData.result.match(/^OK/i)) {
            if (this.userData.data && this.userData.data.length > 0) {
                let formData = this.userData.data;

                formData.forEach((record) => {
                    let key = record.key;
                    let fee = this.getFee(key);

                    if (fee) {
                        fee.optOut = true;
                        this.optOut(fee);
                    }
                })
            }
        }
    }
}
</script>

<style scoped>
.western {
    margin-bottom: 1.25rem;
}

.western__fees {
    border-bottom: 1px solid black;
    padding-bottom: .5rem;
}

.western__headers {
    font-size: 16px;
    font-weight: 600;
}

.western__total {
    font-size: 16px;
    font-weight: 600;
}

.western__fee {
    color: #3455db;
}

.western__nofee {
    color: #008040;
}
</style>